export default __webpack_public_path__ + "static/cash_game-bf786dc3906a2055ce217c6b80ab560d.png";